module.exports = __webpack_public_path__ + "static/media/about.8cdf87b0.png";